import React from 'react';
import { FormDrawer } from './FormDrawer';
import { getDeliveryStatusOptions } from '../../utils/deliveryStatus';

/**
 * Formulario para editar un tramo de entrega.
 */
export const LogisticsLegForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  formData,
  onChange,
  formError = '',
  tripOptions = [],
  zIndex = 11000,
}) => {
  const legStatusOptions = getDeliveryStatusOptions().map((label) => ({
    value: label,
    label,
  }));

  const sections = [
    {
      key: 'context',
      title: 'Tramo',
      fields: [
        {
          key: 'leg_code',
          label: 'Código tramo',
          readOnly: true,
          disabled: true,
        },
        {
          key: 'delivery_code',
          label: 'Entrega',
          readOnly: true,
          disabled: true,
        },
        {
          key: 'leg_status',
          label: 'Estado',
          type: 'select',
          options: legStatusOptions,
        },
        {
          key: 'trip_id',
          label: 'Viaje',
          type: 'select',
          options: [{ value: '', label: 'Sin viaje' }, ...tripOptions],
          fullWidth: true,
        },
      ],
    },
    {
      key: 'route',
      title: 'Ruta y operación',
      fields: [
        {
          key: 'origin_location',
          label: 'Origen',
        },
        {
          key: 'destination_location',
          label: 'Destino',
        },
        {
          key: 'carrier_name',
          label: 'Transportista',
        },
        {
          key: 'eta_close',
          label: 'ETA cierre',
          type: 'date',
        },
        {
          key: 'tracking_code',
          label: 'Tracking',
        },
        {
          key: 'weight_kg',
          label: 'Peso (kg)',
          type: 'number',
          step: '0.01',
        },
        {
          key: 'stop_order',
          label: 'Orden de parada',
          type: 'number',
          step: '1',
        },
        {
          key: 'notes',
          label: 'Notas del tramo',
          type: 'textarea',
          rows: 3,
          fullWidth: true,
        },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title="Editar tramo"
      subtitle={
        [formData?.leg_code, formData?.delivery_code].filter(Boolean).join(' · ') ||
        'Actualiza el tramo y su viaje'
      }
      sections={sections}
      formData={formData}
      onChange={onChange}
      formError={formError}
      width={640}
      saveLabel="Guardar tramo"
      zIndex={zIndex}
    />
  );
};

export default LogisticsLegForm;
